module.exports = __webpack_public_path__ + "static/img/human-right_01_2025.5fd09fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/human-right_01_2025.jpg
// module id = sX5V
// module chunks = 98